"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.request = void 0;
require("whatwg-fetch");
var _constants = require("./constants");
function parseJSON(response) {
  if (response.status === _constants.httpStatusCodes.noContent || response.status === _constants.httpStatusCodes.resetContent) {
    return null;
  }
  return response.text();
}
function checkStatus(response) {
  if (response.status >= _constants.httpStatusCodes.ok && response.status < _constants.httpStatusCodes.multipleChoices) {
    return response;
  }
  const error = new Error(response.statusText);
  error.response = response;
  throw error;
}
const request = (url, options) => {
  return fetch(url, options).then(checkStatus).then(parseJSON);
};
exports.request = request;